import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import imageCompression from "browser-image-compression";
import { withRouter } from "react-router-dom";

let char = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
let charlength = char.length;
let result = "";
for (let i = 0; i < 6; i++) {
  result += char.charAt(Math.floor(Math.random() * charlength));
}
class AddOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {

      NumRegex: /^[0-9]*$/,

      orderid: new URLSearchParams(this.props.location.search).get('id') ,
      ItemCode: "",
      ItemName: "",
      ItemUm: "",

      CustomerData: [],
      customerId: null,
      customerName: "",
      customerContact: "",
      CustomerAddress: "",
      customerCode: "",

      ShowCustomerList: false,


      OrderNumber: "",
      itemData: [],
      status: "",
      orderDate: "",
      quantity: null,
      ItemId: null,
      divOpen: false,
      mainArray: [],
      filteredItem: [],
      selectItem: false,
      ItemList: [],

      AddItems: false,
      AddItemList: [],
    };
  }

  componentDidMount() {




    Notiflix.Loading.Init({ svgColor: "#fa6e03", });

    if (this.state.orderid != null) {
      this.fetchorder()
      this.fetchorderitems()
    }

    this.fetchcustomermaster();

    // this.fetchItem();
  }


  fetchcustomermaster() {

    PostApiCall.postRequest(
      {
        WhereClause: ``,
      },
      "getcustomer"
    ).then((results) =>
      // const objs = JSON.parse(result._bodyText)
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          // console.log(obj.data)
          this.setState({ CustomerData: obj.data, });
          Notiflix.Loading.Remove();
        }
      })
    )
  }


  fetchorder() {

    PostApiCall.postRequest(
      {
        WhereClause: `where fld_order_id=${this.state.orderid}`,
      },
      "getorderheader"
    ).then((results) =>
      // const objs = JSON.parse(result._bodyText)
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          console.log(obj.data)
          this.setState({ customerId : obj.data[0].fld_customer_id, customerName: obj.data[0].fld_customer_name, customerCode : obj.data[0].fld_customer_code, customerContact: obj.data[0].fld_customer_number, CustomerAddress: obj.data[0].fld_customer_address });
          Notiflix.Loading.Remove();
        }
      })
    )
  }


  fetchorderitems() {

    // console.log(this.state.orderid)

    PostApiCall.postRequest(
      {
        WhereClause: `where fld_order_id=${this.state.orderid}`,
      },
      "getorderdetails"
    ).then((results) =>
      // const objs = JSON.parse(result._bodyText)
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          // console.log(obj.data)
          this.setState({
            ItemList: obj.data, AddItems: obj.data.length > 0 ? true : false
          });
          Notiflix.Loading.Remove();
        }
      })
    )
  }


  fetchItem() {
    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        WhereClause: "",
      },
      "getitemmaster"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          // console.log(obj.data);
          this.setState({
            itemData: obj.data,
            filteredItem: obj.data,
          });
          Notiflix.Loading.Remove();
        }
      })
    );
  }


  fillItem = () => {
    this.setState({});
  };


  addOrder = () => {
    if (this.state.customerName != "") {
      if (this.state.OrderNumber != "") {
        if (this.state.ItemName != "") {
          if (this.state.ItemUm != "") {
            if (this.state.quantity != null) {
              if (this.state.ItemCode != "") {

                Notiflix.Loading.Dots("Please wait...");

                // var login = localStorage.getItem("orderid");
                // var details = JSON.parse(login);

                PostApiCall.postRequest(
                  {
                    itemid: this.state.ItemId,
                    orderid: this.state.orderid,
                    customername: this.state.customerName,
                    customercontact: this.state.customerContact,
                    ordernumber: this.state.OrderNumber,

                    itemcode: this.state.selectItem ? null : this.state.ItemCode,
                    itemname: this.state.selectItem ? null : this.state.ItemName,
                    quantity: this.state.quantity,
                    uom: this.state.selectItem ? null : this.state.ItemUm,
                    status: this.state.selectItem ? null : this.state.status,
                  },
                  "addorder"
                ).then((results) =>
                  results.json().then((obj) => {
                    if (results.status == 200 || results.status == 201) {
                      Notiflix.Loading.Remove();
                      Notiflix.Notify.Success("Data is successfully Updated/Added.");

                    
                      this.setState({
                        orderid: localStorage.getItem("ORDERID"),
                        ItemCode: "",
                        ItemName: "",
                        ItemUm: "",
                        status: "",
                        selectItem: false,
                        quantity: null,
                        filteredItem: this.state.itemData

                      }, () => {
                        this.fetchorderitems()
                        this.fetchItem()
                      });
                    } else {
                      Notiflix.Loading.Remove();
                      Notiflix.Notify.Failure(obj.data);
                    }
                  })
                );
              } else {
                Notiflix.Notify.Failure("Please Enter Item Code")
              }
            } else {
              Notiflix.Notify.Failure("Please Enter Quantity")
            }
          } else {
            Notiflix.Notify.Failure("Please Enter Measurement Unit")
          }
        } else {
          Notiflix.Notify.Failure("Please Enter Item Name")
        }
      } else {
        Notiflix.Notify.Failure("Please Enter Order Number")
      }
    } else {
      Notiflix.Notify.Failure("Please Enter Name")
    }

  };

 

  render() {

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title={"Kalanjiam Hardware Store"} breadcrumbItem={"Create Order"} />

            <Card>
              <div className="Bechofy-bg-soft-pink" >
                <Row>
                  <Col xs="6">
                    <div className="Bechofy-text p-3">
                      <h5 className="Bechofy-text text-white">Create Order</h5>
                    </div>
                  </Col>
                </Row>
              </div>

              <Row>
                <Col xl="12">
                  <Card>
                    <CardBody className="pt-0" style={{ height: "100%" }}>
                      <Row>
                        <div class="col-md-12" style={{ marginTop: "12px" }}>
                          <Row>
                            <Col xs="4" className="mb-3">
                              <div>
                                <label>
                                  Customer Name <span style={{ color: "red" }}> *</span>
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  value={this.state.customerName}
                                  onFocus={() => this.setState({ ShowCustomerList: true })}
                                  // onMouseLeave={() => this.setState({ ShowCustomerList: false })}
                                  onChange={(text) => {
                                    this.setState({
                                      customerName: text.target.value,
                                    });
                                  }}
                                ></input>
                              </div>

                              {this.state.ShowCustomerList &&

                                <div className="main-dropdown-div">
                                  <ul className="item-list"  >
                                    {this.state.CustomerData.filter(val => val).map((item, index) => {
                                  
                                      return (
                                        <li
                                          className="item-element" style={{ cursor: "pointer" }}
                                          key={index}
                                          // value={item.fld_item_id}
                                          onClick={() => {
                                            this.setState({ customerId: item.fld_customer_id, customerName: item.fld_customer_name, customerContact: item.fld_customer_number, customerCode: item.fld_customer_code, CustomerAddress: item.fld_customer_address, ShowCustomerList: false })
                                          }}
                                        >
                                          {item.fld_customer_name}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                              }
                            </Col>

                            <Col xs="4" className="mb-3">
                              <div>
                                <label> Customer Code <span style={{ color: "red" }}> *</span> </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  value={this.state.customerCode}
                                  onFocus={() => this.setState({ ShowCustomerList: false })}
                                  onChange={(text) => {
                                    this.setState({
                                      customerCode: text.target.value,
                                    });
                                  }}
                                ></input>
                              </div>
                            </Col>

                            <Col xs="4" className="mb-3">
                              <div>
                                <label> Customer Contact <span style={{ color: "red" }}> *</span> </label>
                                <input
                                  className="form-control"
                                  type="number"
                                  value={this.state.customerContact}
                                  onChange={(mobile) => {
                                    if (this.state.NumRegex.test(mobile.target.value) && mobile.target.value.length <= 10) {
                                      this.setState({ customerContact: mobile.target.value });
                                    }
                                  }}
                                ></input>
                              </div>
                            </Col>

                            <Col xs="12" className="mb-3">
                              <div>
                                <label> Customer Address <span style={{ color: "red" }}> *</span> </label>
                                <textarea
                                  className="form-control"
                                  type="number"
                                  value={this.state.CustomerAddress}

                                  onChange={(text) => {
                                    this.setState({
                                      CustomerAddress: text.target.value,
                                    });
                                  }}
                                ></textarea>
                              </div>
                            </Col>



                            {/* <Col xs="4">
                              <div>
                                <label>
                                  Order Number <span style={{ color: "red" }}> *</span>
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  value={this.state.OrderNumber}
                                  onChange={(text) => this.setState({ OrderNumber: text.target.value })}
                                ></input>
                              </div>
                            </Col> */}
                          </Row>

                          <div className="row m-0 my-3 justify-content-end">
                            {/* <button className="col-auto btn btn-secondary"
                              onClick={() => this.setState({ AddItems: !this.state.AddItems })}
                              style={{ width: "10rem", marginTop: "12px", }}>Add Items
                            </button> */}


                            {!this.state.AddItems && <button className="col-auto btn btn-secondary"
                              onClick={() => {

                                if (this.state.customerName != "") {
                                  if (this.state.customerContact != "") {
                                    if (this.state.customerContact.length == 10) {
                                      if (this.state.CustomerAddress != "") {

                                        Notiflix.Loading.Dots("Please wait...");

                                        PostApiCall.postRequest(
                                          {
                                            orderid: this.state.orderid,
                                            customerid: this.state.customerId,
                                            customercode: this.state.customerCode,
                                            customername: this.state.customerName,
                                            customercontact: this.state.customerContact,
                                            customeraddress: this.state.CustomerAddress,
                                          },
                                          "addorder"
                                        ).then((results) =>
                                          results.json().then((obj) => {
                                            if (results.status == 200 || results.status == 201) {
                                              Notiflix.Loading.Remove();
                                              Notiflix.Notify.Success("Data is successfully Updated/Added.");
                                              window.location.href = "/order-master"
                                            } else {
                                              Notiflix.Loading.Remove();
                                              Notiflix.Notify.Failure(obj.data);
                                            }
                                          })
                                        )
                                      } else {
                                        Notiflix.Notify.Failure("Please Enter Address")
                                      }
                                    } else {
                                      Notiflix.Notify.Failure("Please Enter Valid Number")
                                    }
                                  } else {
                                    Notiflix.Notify.Failure("Please Enter Number")
                                  }
                                } else {
                                  Notiflix.Notify.Failure("Please Enter Name")
                                }



                              }}
                              style={{
                                width: "10rem",
                                marginTop: "12px",
                              }} >Save
                            </button>
                            }
                          </div>



                          {this.state.AddItems &&
                            <Col xs="12" >
                              <div className="form mt-5 mb-4">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="row ">
                                      <div className="col-md-3 dropdown-div"

                                        onMouseEnter={() => this.setState({ divOpen: true })}

                                        onMouseLeave={() => this.setState({ divOpen: false })} >
                                        <label>
                                          Select Item Name <span style={{ color: "red" }}> *</span>
                                        </label>
                                        <input
                                          className="form-control dropdown-div"
                                          type="text"
                                          value={this.state.ItemName}
                                          onChange={(e) => {
                                            this.setState({
                                              ItemName: e.target.value,
                                            });
                                            let filterArray = [...this.state.itemData];
                                            filterArray = filterArray.filter((item) => {
                                              return item.fld_item_name?.startsWith(e.target.value);
                                            });
                                         
                                            this.setState({
                                              filteredItem: filterArray,
                                            });
                                          }}

                                        ></input>

                                        {this.state.divOpen && (
                                          <div className="main-dropdown-div">
                                            <ul className="item-list" onMouseLeave={() => this.setState({ divOpen: false })}>
                                              {this.state.filteredItem.map((item, index) => {
                                                {/* const { fld_item_id, fld_item_name } = item; */ }
                                                return (
                                                  <li
                                                    className="item-element" style={{ cursor: "pointer" }}
                                                    key={index}
                                                    // value={item.fld_item_id}
                                                    onClick={() => this.setState({ ItemId: item.fld_item_id, ItemName: item.fld_item_name, ItemCode: item.fld_item_code, ItemUm: item.fld_uom, status: item.fld_status, selectItem: true, divOpen: false })
                                                    }
                                                  >
                                                    {item.fld_item_name}
                                                  </li>
                                                );
                                              })}
                                            </ul>
                                          </div>
                                        )}
                                      </div>
                                      <div className="col-md-3">
                                        <label>
                                          Unit Of Measurement <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                          className="form-control"
                                          value={this.state.ItemUm}
                                          onChange={(text) => {
                                            this.setState({
                                              ItemUm: text.target.value,
                                            });
                                          }}

                                        // disabled={this.state.selectItem}
                                        />
                                      </div>
                                      <div className="col-md-3">
                                        <label>
                                          Quantity <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={this.state.quantity}
                                          onChange={(text) => {
                                            this.setState({
                                              quantity: text.target.value,
                                            });
                                          }}
                                        />
                                      </div>

                                      <div className="col-md-3">
                                        {" "}
                                        <label>
                                          Item Code <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={this.state.ItemCode}
                                          onChange={(text) => {
                                            this.setState({
                                              ItemCode: text.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>


                                    <Row>

                                      {/* <Col>
                                    {" "}
                                    <label>
                                      Status <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      value={this.state.status}
                                      className="form-control"
                                      onChange={(e) => {
                                        this.setState({
                                          status: e.target.value,
                                        });

                                      }}
                                    > <option value="">Select...</option>
                                      <option value="active">Active</option>
                                      <option value="inactive">Inactive</option>
                                    </select>
                                  </Col> */}
                                    </Row>
                                    <Row>
                                      <Col xs="10"></Col>
                                      <Col>
                                        <Button
                                          className=" btn gtrendz-btn-save"
                                          style={{
                                            width: "10rem",
                                            marginTop: "12px",
                                          }}

                                          onClick={this.addOrder.bind(this)}
                                        >
                                          Add
                                        </Button>
                                      </Col>
                                    </Row>
                                    <br></br>
                                    <div
                                      class="table-wrapper-scroll-y my-custom-scrollbar "
                                      style={{
                                        maxHeight: "310px",
                                        marginTop: "30px",
                                      }}
                                    >
                                      <table
                                        class="table table-bordered table-striped mb-0"
                                        style={{ textAlign: "center" }}
                                      >
                                        <thead>
                                          <tr>
                                            <th>S.No.</th>
                                            <th>Item Code</th>
                                            <th>Item Name</th>
                                            <th>Unit of Management</th>
                                            <th>Quantity</th>
                                            <th>Status</th>
                                          </tr>
                                        </thead>
                                        <tbody>

                                          {this.state.ItemList.map((data, i) => {
                                            return (
                                              <tr>
                                                <td>{i + 1}</td>
                                                <td>{data.fld_item_code}</td>
                                                <td>{data.fld_item_name}</td>
                                                <td>{data.fld_uom}</td>
                                                <td>{data.fld_quantity}</td>
                                                <td>{data.fld_status}</td>
                                              </tr>
                                            )
                                          })}

                                        </tbody>
                                      </table>
                                    </div>


                                    <div className="row justify-content-end  m-0  mt-5">

                                      <Button
                                        className="  col-auto btn btn-secondary"
                                        style={{
                                          width: "10rem",
                                          marginTop: "12px",
                                        }}

                                        onClick={() => {
                                          localStorage.removeItem("ORDERID")
                                          window.location.href = "/order-list"
                                        }}
                                      >
                                        Finish
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          }

                        </div>

                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withRouter(AddOrder);




